export const POSTER_FOLDER_NAME = 'Poster'